import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutTariffManagementList extends Layout {
    layoutHeaderTariffManagement: LayoutHeader;
    sourceTariff: DataSource;
    tableTariffManagement: Table;
}
